import axios from 'axios';
import { v4 as uuidv4 } from 'uuid';
import TimeCalculation from './TimeCalculation';
import { getLocale, isTestPlatform } from './functions';

export const BASE_URL = isTestPlatform() ? 'https://mesus-test.kube.severstal.severstalgroup.com' : process.env.REACT_APP_BASE_URL || window.location.origin;
export const API_BASE = `${BASE_URL}/api`;
function timeout(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}
async function sleep() {
  await timeout(300);
}

const defaultConfig = {
  headers: {
    'Accept-Language': getLocale(),
    'Content-Type': 'application/json'
  }
};

export const http = axios.create({ baseURL: API_BASE });

http.interceptors.response.use(
  (response) => response,
  async (error) => {
    let originalRequest = error.config;
    // eslint-disable-next-line no-underscore-dangle
    if (error.response && error.response.status === 401 && !originalRequest._retry && error.config.url !== 'logout/') {
      originalRequest = {
        ...originalRequest,
        _retry: true
      };
      if (!localStorage.getItem('error_401')) {
        localStorage.setItem('error_401', 'true');
        try {
          await http.post('logout/', {}, { headers: { 'WWW-Authenticate': 'Negotiate' } });
          await http.get('user/info', {
            ...error.config,
            _retry: true
          });
          if (document?.dxFunctionsAfterConnect && Array.isArray(document.dxFunctionsAfterConnect)) {
            await Promise.all(document.dxFunctionsAfterConnect.map((item) => item()));
          }
        } finally {
          localStorage.removeItem('error_401');
        }
      } else {
        let i = 0;
        while (localStorage.getItem('error_401')) {
          // eslint-disable-next-line no-await-in-loop
          await sleep();
          if (i >= 20) {
            localStorage.removeItem('error_401');
            break;
          }
          i += 1;
        }
      }
      return http(originalRequest);
    }
    // (error) => {
    throw error;
  }
);

const dataTimeMatomo = new TimeCalculation();

export const get = async (url, config = defaultConfig) => {
  const tempKey = `${uuidv4()}_${(new Date()).valueOf()}`;
  dataTimeMatomo.start(tempKey, url);
  try {
    const answer = await http.get(url, config);
    dataTimeMatomo.stop(tempKey, 'GET');
    const result = answer.data;
    return Promise.resolve(result);
  } catch (error) {
    dataTimeMatomo.stop(tempKey, 'GET (ERROR)');
    return Promise.reject(error);
  }
};

export const del = async (url, payload, config  = defaultConfig) => {
  const tempKey = `${uuidv4()}_${(new Date()).valueOf()}`;
  dataTimeMatomo.start(tempKey, url);
  try {
    const answer = await http.delete(url, {...config, ...(payload && { data: payload })});
    dataTimeMatomo.stop(tempKey, 'DELETE');
    const result = answer.data;
    return Promise.resolve(result);
  } catch (error) {
    dataTimeMatomo.stop(tempKey, 'DELETE (ERROR)');
    return Promise.reject(error);
  }
};

export const post = async (url, payload, config = defaultConfig) => {
  const tempKey = `${uuidv4()}_${(new Date()).valueOf()}`;
  dataTimeMatomo.start(tempKey, url);
  try {
    const answer = await http.post(url, payload, config);
    dataTimeMatomo.stop(tempKey, 'POST');
    const result = answer.data;
    return Promise.resolve(result);
  } catch (error) {
    dataTimeMatomo.stop(tempKey, 'POST (ERROR)');
    return Promise.reject(error);
  }
};

export const axiosPut = async (url, payload, config = defaultConfig) => {
  const tempKey = `${uuidv4()}_${(new Date()).valueOf()}`;
  dataTimeMatomo.start(tempKey, url);
  try {
    const answer = await http.put(url, payload, config);
    dataTimeMatomo.stop(tempKey, 'PUT');
    const result = answer.data;
    return Promise.resolve(result);
  } catch (error) {
    dataTimeMatomo.stop(tempKey, 'PUT (ERROR)');
    return Promise.reject(error);
  }
};

const defaultConfigFile = {
  headers: {
    'Accept-Language': getLocale(),
    'Content-Type': 'application/json'
  }
};

const httpFile = axios.create({
  baseURL: API_BASE,
  responseType: 'blob'
});

httpFile.interceptors.response.use(
  (response) => response,
  (error) => {
    throw error;
  }
);

export const getFile = async (url, config = defaultConfigFile) => {
  const tempKey = `${uuidv4()}_${(new Date()).valueOf()}`;
  dataTimeMatomo.start(tempKey, url);
  try {
    const result = await httpFile.get(url, config);
    dataTimeMatomo.stop(tempKey, 'GET');
    return Promise.resolve(result);
  } catch (error) {
    dataTimeMatomo.stop(tempKey, 'GET (ERROR)');
    return Promise.reject(error);
  }
};

export const postFile = async (url, payload, config = defaultConfigFile) => {
  const tempKey = `${uuidv4()}_${(new Date()).valueOf()}`;
  dataTimeMatomo.start(tempKey, url);
  try {
    const result = await httpFile.post(url, payload, config);
    dataTimeMatomo.stop(tempKey, 'POST');
    return Promise.resolve(result);
  } catch (error) {
    dataTimeMatomo.stop(tempKey, 'POST (ERROR)');
    return Promise.reject(error);
  }
};

export const httpMatomo = axios.create({
  baseURL: API_BASE
});
export const postMatomo = async (url, payload, config = defaultConfig) => {
  try {
    const answer = await httpMatomo.post(url, payload, config);
    const result = answer.data;
    return Promise.resolve(result);
  } catch (error) {
    return Promise.reject(error);
  }
};

export default http;
